module.exports = __webpack_public_path__ + "assets/img/tsgn2.f676b3c3.jpg";